import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isBlank", "className"];
import React from 'react';
import { Button as CarnicaButton } from '@carnica/ui-kit';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect } from "../../utils";
var _Button = function _Button(_ref) {
  var isBlank = _ref.isBlank,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-Button"
  }, /*#__PURE__*/React.createElement(CarnicaButton, _extends({}, props, {
    tagName: "a",
    target: isBlank ? '_blank' : '_self'
  })));
};
export var Button = compose(enhancedConnect(), withAutoMetric.Element(function (props) {
  return {
    name: 'Button',
    text: props.children
  };
}))(_Button);